import { render, staticRenderFns } from "./VenueEditor.vue?vue&type=template&id=2a06413c&scoped=true&"
import script from "./VenueEditor.vue?vue&type=script&lang=ts&"
export * from "./VenueEditor.vue?vue&type=script&lang=ts&"
import style0 from "./VenueEditor.vue?vue&type=style&index=0&id=2a06413c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06413c",
  null
  
)

export default component.exports